import * as React from 'react'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { ShopifyNext } from '@dotdev/next-components'

export class AccountWishlist extends React.Component<AccountWishlist.Props, AccountWishlist.State> {
  public static contextType = ShopifyNext.Context;
  public constructor(props: any) {
    super(props)
    this.state = {
      shareLink: null,
      products: null,
      loading: false,
      showEmptyState: false
    }
  }
  
  public componentDidMount = () => {
    // Remove the accountView from localStorage when wishlist component mounts
    localStorage.removeItem('accountView')

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }
    
    window.SwymCallbacks.push(this.fetchWishlistItems)
    
    if (this.props.data.customer) {
      window.SwymCallbacks.push(this.setShareURL)
    }
  }
  
  public setShareURL = async () => {
    let _this = this
    if (!window._swat || !window._swat.retailerSettings) {
      setTimeout(() => {
        this.setShareURL()
      }, 1000)
    } else {
      let shareUrl = await window._swat.generateSharedListURL(
        null,
        function(data, sharedListId) { // returns the generated URL
          console.log(data)
          return data
        },
        function(err) {
          console.log(err)
        }
      )
      _this.setState({
        shareLink: shareUrl
      })
    }
  }
  
  public fetchWishlistItems = () => {
    let _this = this
    let __wishlistedProducts = []
    let count = 0
    this.setState({
      loading: true
    })
    window._swat?.fetch(function (products) {
      products.forEach(function(product) {
        let {du} = product
        fetch(du + '?view=json')
          .then(response => {
            if (!response.ok) {
              throw new Error(`Product not found: ${du}`)
            }
            return response.text()
          })
          .then(data => {
            let tmp = document.createElement('DIV')
            tmp.innerHTML = data
            const res = tmp.textContent || tmp.innerText || ''
            return JSON.parse(res)
          })
          .then(data => {
            if (data) {
              __wishlistedProducts.push(data)
            }
          })
          .catch(error => {
            console.warn(`Failed to fetch product: ${error.message}`)
          })
          .finally(() => {
            // Check if we've processed all products (whether successful or failed)
            if (products.length === products.length) {
              const items = __wishlistedProducts.filter(Boolean).map(item => {
                return item.product ? item.product : item
              })
              
              if (items.length > 0) {
                _this.setState({
                products: products.length ? items : []
              })
              document.dispatchEvent(new CustomEvent('swym:wishlist-fetched'))
            } else {
              this.setState({
                wishlist: []
              })
            }
            this.setState({
              loading: false,
              showEmptyState: products.length === 0
            })
          }
        })
      })
    }, window._swat.EventTypes.addToWishlist)

    setTimeout(() => {
      this.setState({
        loading: false,
        showEmptyState: true
      })
    }, 1000)

    console.log("wishlist: ", this.state)
  };

  public removeProduct = (productId: number, variantId: number, productUrl: string) => {
    // ShopifyNext.Wishlist.removeItem(productId, variantId)
    const _this = this
    const productData = {
      et: 4, // et 4 stands for wishlist event type
      epi: variantId, // unique variant ID of the product.
      empi: productId, // Product ID or master product ID
      du: `${window.location.origin}${productUrl}`,
    }
    
    if (!window._swat || !window._swat.retailerSettings) {
      // console.error("Swat is not initialized");
      setTimeout(() => {
        _this.removeProduct(productId, variantId, productUrl)
      }, 1000)
    } else {
      window._swat.removeFromWishList(
        productData,
        function (e: any) {
          console.log('wishlist item removed', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    }
  }

  public render(): JSX.Element {
    const { shareLink, products, loading, showEmptyState } = this.state

    return (
      <React.Fragment>
        <div className={'hidden md:block absolute top-0 inset-x-0 z-10 bg-white px-1-7 md:px-0 flex flex-between'}>
          <Snippets.Heading size={'h1'} tag={'h1'} className={'w-full md:pb-3-2 md:border-b md:border-grey-border mb-3-2'}>Wishlist</Snippets.Heading>
          {products && products.length ? <Snippets.AccountWishlistSharelink className={'hidden md:flex absolute top-0 right-0 flex-row justify-end items-center'} shareLink={shareLink} /> : null}
        </div>
        <div className={'w-full flex flex-wrap mt-5-2 md:mt-0'}>
          {products && products.length ? products.map(item => {
            const { variants } = item
            const variant = variants[0]
            return (
              <Snippets.AccountWishlistItem
                key={`${item.id} ${variant.id}`}
                {...this.props}
                productId={item.id}
                variantId={variant.id}
                product={{ ...item, selected_or_first_available_variant: variant.id }}
                variant={variant}
                removeProduct={this.removeProduct} />
            )
          }) : <Snippets.Heading size={'h2'} tag={'p'} className={'pb-2-4'}>{loading ? 'Loading...' : showEmptyState ? 'Your Wishlist is empty' : 'Loading...'}</Snippets.Heading>}
          {products && products.length ? <Snippets.AccountWishlistSharelink className={'flex md:hidden flex-row justify-center items-center'} shareLink={shareLink} /> : null}
        </div>
      </React.Fragment>
    )
  }
}

export namespace AccountWishlist {
  export interface Props extends GlobalProps { }
  export interface State {
    shareLink: any;
    products: any;
    loading: boolean;
    showEmptyState: boolean;
  }
}
